/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get, isEmpty } from 'lodash';

import clipboard from 'shared/ui/mixins/clipboard';

import UnlayerEditor from 'shared/ui/components/editors/email/UnlayerEditor.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import SecondaryToolbar from 'shared/ui/components/form-components/SecondaryToolbar.vue';
import BaseTextarea from 'shared/ui/components/form-components/BaseTextarea.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';

const __vue_script__ = {
    name: 'EmailEditor',

    components: {
        BaseInput,
        SecondaryToolbar,
        UnlayerEditor,
        Toggler,
        BaseTextarea,
        RadioButtons
    },

    mixins: [clipboard],

    props: {
        params: {
            type: Object,
            required: true
        },
    },

    data() {
        const { modelId, templateId } = this.$router.getRouteParams();
        return {
            eid: this.params.event.id,
            form: {},
            isFullScreen: false,
            isNew: false,
            editorLoaded: false,
            processing: false,
            template: {},
            html: '',
            templateId: templateId || modelId,
            ready: false,
            metadataFields: {},
            /** @type {{value:string,label:string}[]} */
            editorTypeOptions: [
                { value: 'editor', label: this.$t('email_templates_editor.mode_switch_btn_label_on') },
                { value: 'textarea', label: this.$t('email_templates_editor.mode_switch_btn_label_off') },
            ],
            /** @type {'editor'|'textarea'|undefined} */
            editorType: undefined,
        };
    },

    computed: {
        is_active: {
            /** @returns {boolean} */
            get: function() {
                return !this.form.is_inactive;
            },
            /** @param {boolean} active */
            set: function(active) {
                this.form.is_inactive = !active;
            }
        }
    },

    async created() {
        await this.loadMetadata();
        if (this.templateId) {
            await this.loadTemplate();
            this.editorType = isEmpty(this.template.design) ? 'textarea' : 'editor';
        } else {
            this.editorType = 'editor';
            this.isNew = true;
            this.form = {
                is_inactive: false,
                from: `SpotMe Support <noreply@${this.$const.EMAIL_DOMAIN}>`
            };
        }
    },

    async mounted() {
        await this.checkClipboardSupport();
        this.ready = true;
    },

    methods: {
        async loadMetadata() {
            try {
                this.metadataFields = await this.$services.metadata.getMetadata(this.eid);
            } catch (error) {
                console.error('[EmailEditor] Could not load metadata:', error);
                this.$notify({
                    group: 'flashes',
                    title: this.$t('general.error_occurred').toString(),
                    text: this.$t('email_templates_editor.metadata_error').toString(),
                    type: 'error',
                    duration: 10000,
                });
            }
        },

        async loadTemplate() {
            try {
                const doc = await this.$services.documents.getDocById(this.eid, this.templateId);

                if (!doc) {
                    this.gotoTemplateList();
                    return;
                }

                this.template = doc;
                this.html = doc.html;
                this.form = {
                    is_inactive: doc.is_inactive,
                    design: doc.design,
                    from: doc.from,
                    html: doc.html,
                    template_name: doc.template_name,
                    subject: doc.subject ?? '',
                };

            } catch (error) {
                console.error('[EmailEditor] Could not fetch template:', error);
                this.$notify({
                    group: 'flashes',
                    title: this.$t('general.error_occurred').toString(),
                    text: this.$t('email_templates_editor.template_error').toString(),
                    type: 'error',
                    duration: 10000,
                });
            }
        },

        gotoTemplateList() {
            const module = this.$services.blueprint.getModuleByName('emailing');
            const controllerRoute = get(module, 'controllers.templates.route') || '';
            const route = controllerRoute.replace(':eventId', this.eid);

            this.$router.push(route);
        },

        /**
         * Ask the child editor to update the design/html. Used for saving.
         */
        async updateForm() {
            if (this.editorType === 'textarea') {
                this.form.html = this.html;
                this.form.design = {};
            } else {
                const { design, html } = await this.$refs.unlayerEditor.getDesignAndHtml();
                this.form.html = html;
                this.form.design = design;
            }
        },

        /**
         * Callback when editor is loaded
         *
         * @param {Boolean} loaded editor is loaded or not
         */
        onEditorLoaded(loaded) {
            this.editorLoaded = loaded;
        },

        async save() {
            this.processing = true;

            let messageType = 'success';
            let messageKey = 'email_templates_editor.save_success';
            let messageDuration = 5000;

            try {
                await this.updateForm();
                const { data } = await this.saveRequest();
                if (!isEmpty(data.upsertedDocs)) {
                    this.template._rev = data.upsertedDocs[0].rev;
                }
                if (data.created) {
                    this.gotoTemplateList();
                }
            } catch (err) {
                messageType = 'error';
                messageDuration = 10000;
                if (err.data && typeof err.data.error === 'string')
                    messageKey = err.data.error.split(':').pop();
                else
                    messageKey = 'email_templates_editor.save_error';


                console.error('[EmailEditor] Could not save:', err);
            } finally {
                this.processing = false;

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t(messageKey).toString(),
                    type: messageType,
                    duration: messageDuration,
                });
            }
        },

        async saveRequest() {
            const doc = {
                ...this.template,
                ...this.form
            };
            const eventNode = this.params.event.node;
            const eventId = this.params.event.id;

            return this.isNew
                ? this.$services.documents.createDocs(eventId, eventNode, 'mail_template', doc)
                : this.$services.documents.updateDoc(eventId, eventNode, 'mail_template', doc);
        },

        toggleFullScreen() {
            this.isFullScreen = !this.isFullScreen;
        },

        /**
         * Copies the email data into the clipboard
         */
        async copyTemplate() {
            await this.updateForm();

            const { from, subject, html, design } = this.form;

            await this.copyToClipboard({ from, subject: subject ?? '', html, design });
        },

        /**
         * Paste the email data from the clipboard
         */
        async pasteTemplate() {
            const { design, html, from, subject } = await this.readFromClipboard(['design', 'html', 'from', 'subject']);
            this.template.design = design;
            this.html = html;
            this.form = {
                ...this.form,
                design,
                html,
                from,
                subject
            };
        },
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"email-editor-page",attrs:{"v-if":_vm.ready}},[_c('div',{staticClass:"config"},[_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},[_c('base-input',{attrs:{"type":"text","name":"name","label":"Name"},model:{value:(_vm.form.template_name),callback:function ($$v) {_vm.$set(_vm.form, "template_name", $$v)},expression:"form.template_name"}}),_c('toggler',{attrs:{"name":"active"},model:{value:(_vm.is_active),callback:function ($$v) {_vm.is_active=$$v},expression:"is_active"}})],1)]),_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},[_c('base-input',{attrs:{"type":"text","name":"from","label":"From"},model:{value:(_vm.form.from),callback:function ($$v) {_vm.$set(_vm.form, "from", $$v)},expression:"form.from"}}),_c('base-input',{attrs:{"type":"text","name":"subject","label":"Subject","tip":_vm.$t('email_templates_editor.subject')},model:{value:(_vm.form.subject),callback:function ($$v) {_vm.$set(_vm.form, "subject", $$v)},expression:"form.subject"}})],1)]),_c('div',{staticClass:"header"},[_c('h4',{staticClass:"header-label"},[_vm._v(_vm._s(_vm.$t('email_templates_editor.label')))]),(_vm.isNew)?_c('radio-buttons',{attrs:{"name":"editorType","options":_vm.editorTypeOptions,"inline":true},model:{value:(_vm.editorType),callback:function ($$v) {_vm.editorType=$$v},expression:"editorType"}}):_vm._e()],1)]),_c('div',{staticClass:"unlayer-wrapper",class:{ 'unlayer-fullscreen': _vm.isFullScreen },attrs:{"name":"html"}},[(_vm.editorLoaded && _vm.editorType === 'editor')?_c('a',{staticClass:"btn btn-primary btn-icon single switch-fullscreen",on:{"click":_vm.toggleFullScreen}},[_c('i',{class:_vm.isFullScreen ? 'icon-resize-small' : 'icon-resize-full-screen'})]):_vm._e(),(_vm.editorType === 'editor')?_c('unlayer-editor',{ref:"unlayerEditor",attrs:{"options":{ user: { id: _vm.eid } },"eid":_vm.eid},on:{"loaded":_vm.onEditorLoaded},model:{value:(_vm.template.design),callback:function ($$v) {_vm.$set(_vm.template, "design", $$v)},expression:"template.design"}}):_vm._e(),(_vm.editorType === 'textarea')?_c('base-textarea',{attrs:{"rows":23,"name":"template"},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}}):_vm._e()],1),_c('secondary-toolbar',[_c('div',{staticClass:"contextual"},[(_vm.clipboardSupported && (_vm.editorLoaded || _vm.editorType === 'textarea'))?_c('a',{staticClass:"btn btn-icon",on:{"click":function($event){return _vm.copyTemplate()}}},[_c('i',{staticClass:"ic-email-template-copy"}),_vm._v(_vm._s(_vm.$t('email_templates_editor.copy_template_to_clipboard')))]):_vm._e(),(_vm.clipboardSupported && (_vm.editorLoaded || _vm.editorType === 'textarea'))?_c('a',{staticClass:"btn btn-icon",on:{"click":function($event){return _vm.pasteTemplate()}}},[_c('i',{staticClass:"ic-email-template-paste"}),_vm._v(_vm._s(_vm.$t('email_templates_editor.paste_template_from_clipboard')))]):_vm._e()]),_c('div',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.processing},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EmailEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__